import axios from "axios";
import AxiosClient from "../../../services/axios.services";

class CollaboratorsEvaluateServices {
  getCollaboratorsEvaluate = (params) =>
    AxiosClient.get("/api/app/evaluacion_seleccion_colaborador_evaluar/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  getCollaboratorToEvaluateGeneral = (params) =>
    AxiosClient.get(`/api/app/evaluacion_colaborador_seleccionado/`, {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  getEvaluators = (params) =>
    AxiosClient.get(`/api/app/evaluacion_seleccion_evaluador/`, {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

    getPeriod = (params) =>
    AxiosClient.get(`/api/app/validacion_periodo_evaluacion/`, {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  saveCollaboratorsEvaluateGeneral = (data) =>
    AxiosClient.post("/api/app/evaluacion_colaborador_seleccionado/", data, {
      headers: { "Content-Type": "application/json" },
    });

  saveEvaluators = (data) =>
    AxiosClient.post("/api/app/evaluacion_evaluador/", data, {
      headers: { "Content-Type": "application/json" },
    });

  editCollaboratorsEvaluateGeneral = (id, data) =>
    AxiosClient.put(
      `/api/app/evaluacion_colaborador_seleccionado/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  editEvaluators = (id, data) =>
    AxiosClient.put(`/api/app/evaluacion_evaluador/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });

  deleteCollaboratorsEvaluateGeneral = (id) =>
    AxiosClient.delete(`/api/app/evaluacion_colaborador_seleccionado/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new CollaboratorsEvaluateServices();
